import React from 'react'
import { Link as GLink } from 'gatsby'
import { Heading } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'


const CardBodyTitle = ({ variant, title, slug, link }) => {
  const linkProps = link
    ? {
        as: 'a',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : {
        as: GLink,
        to: slug
      }
  return (
    <Heading {...linkProps} sx={{ 
      variant: rv(variant, 'title'), 
      fontSize: '20px',
      '@media (max-width: 991px)': {
        fontSize: '18px',
      }
      }}>
      {title}
    </Heading>
  )
}

export default CardBodyTitle
